import React from 'react';
import { Route } from 'react-router-dom';
import { FlagGate } from '../features/featureFlags/components/FlagGate';
import { FeatureFlagName } from '../features/featureFlags/types';
import { MainLayout } from '../layouts/MainLayout';
import { AuthLayout } from '../layouts/AuthLayout';

const Catalog = React.lazy(() => import('../pages/Catalog').then((m) => ({ default: m.Catalog })));
const Detail = React.lazy(() => import('../pages/Detail').then((m) => ({ default: m.Detail })));
const CookbookCatalog = React.lazy(() =>
  import('../pages/CookbookCatalog').then((m) => ({ default: m.CookbookCatalog })),
);
const CookbookDetailPage = React.lazy(() =>
  import('../pages/CookbookDetailPage').then((m) => ({ default: m.CookbookDetailPage })),
);
const CookbookFormPage = React.lazy(() =>
  import('../pages/CookbookFormPage').then((m) => ({ default: m.CookbookFormPage })),
);
const WeeklyPlanner = React.lazy(() =>
  import('../pages/WeeklyPlanner/WeeklyPlanner').then((m) => ({ default: m.WeeklyPlanner })),
);
const SettingsPage = React.lazy(() =>
  import('../features/settings/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })),
);
const IngredientsListPage = React.lazy(() =>
  import('../features/ingredients/pages/IngredientsListPage').then((m) => ({
    default: m.IngredientsListPage,
  })),
);
const IngredientDetailPage = React.lazy(() =>
  import('../features/ingredients/pages/IngredientDetailPage').then((m) => ({
    default: m.IngredientDetailPage,
  })),
);
const ImportJobsListPage = React.lazy(() =>
  import('../features/recipeImport/pages/ImportJobsListPage').then((m) => ({
    default: m.ImportJobsListPage,
  })),
);
const GroupsPage = React.lazy(() =>
  import('../features/groups/pages/GroupsPage').then((m) => ({ default: m.GroupsPage })),
);
const GroupDetailPage = React.lazy(() =>
  import('../features/groups/pages/GroupDetailPage').then((m) => ({ default: m.GroupDetailPage })),
);
const OAuthAuthorizePage = React.lazy(() =>
  import('../pages/OAuthAuthorizePage').then((m) => ({ default: m.OAuthAuthorizePage })),
);
const ChallengesPage = React.lazy(() =>
  import('../pages/challenges/ChallengesPage').then((m) => ({ default: m.ChallengesPage })),
);
const ChallengeDetailPage = React.lazy(() =>
  import('../pages/challenges/ChallengeDetailPage').then((m) => ({ default: m.ChallengeDetailPage })),
);
const ChallengeNewsPostDetailPage = React.lazy(() =>
  import('../pages/challenges/ChallengeNewsPostDetailPage').then((m) => ({
    default: m.ChallengeNewsPostDetailPage,
  })),
);

/** Main app routes — rendered inside the AppMenu shell (MainLayout). */
export function mainRoutes() {
  return (
    <>
      <Route element={<MainLayout />}>
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/recipes/:id" element={<Detail />} />
        <Route path="/cookbooks" element={<CookbookCatalog />} />
        <Route path="/cookbooks/new" element={<CookbookFormPage />} />
        <Route path="/cookbooks/:id/edit" element={<CookbookFormPage />} />
        <Route path="/cookbooks/:id" element={<CookbookDetailPage />} />
        <Route path="/planner" element={<WeeklyPlanner />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/ingredients" element={<IngredientsListPage />} />
        <Route path="/ingredients/:id" element={<IngredientDetailPage />} />
        <Route
          path="/recipes/imports"
          element={
            <FlagGate flag={FeatureFlagName.IMPORT_SOURCES} redirect="/catalog">
              <ImportJobsListPage />
            </FlagGate>
          }
        />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:id" element={<GroupDetailPage />} />
        <Route path="/challenges" element={<ChallengesPage />} />
        <Route path="/challenges/:id" element={<ChallengeDetailPage />} />
        <Route path="/challenges/:id/news/:postId" element={<ChallengeNewsPostDetailPage />} />
      </Route>
      {/* Consent screen — standalone layout, no AppMenu chrome */}
      <Route element={<AuthLayout />}>
        <Route path="/oauth/authorize" element={<OAuthAuthorizePage />} />
      </Route>
    </>
  );
}
